import tw from 'tailwind-styled-components';

const styles = `
  stroke-white
  cursor-pointer
  transition-[fill]
  duration-[0.5s]
  ease-in
`;

export const MapContainer = tw.div`
  h-auto
  overflow-hidden
  mx-0
  my-[2em]
  sm:hidden
  md:block
`;

export const MapSvg = tw.svg`
  block
  w-[100%]
  overflow-hidden
  my-0
  mx-auto
  sm:h-[53vw]
  md:h-[53vw]
  lg:h-[30em]
  xl:h-[30em]
  2xl:h-[30em]
`;

/**** Recreational ****/
export const RecreationalG = tw.g<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

export const RecreationalPath = tw.path<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

export const RecreationalPolyline = tw.polyline<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

/**** Full Medical Use ****/
export const MedicalG = tw.g<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

export const MedicalPath = tw.path<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

export const MedicalPolyline = tw.polyline<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

/**** Limited Medical Use ****/
export const LimitedPath = tw.path<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

export const LimitedPolyline = tw.polyline<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

/**** Not Legal ****/
export const NotLegalPath = tw.path<{ $isDispensary?: boolean }>`
  ${((p)=>p.$isDispensary ? 'fill-[#00461e] hover:fill-[#91b16a]' : 'fill-[grey] hover:cursor-not-allowed hover:fill-[#CF4520]')}
  ${() => styles}
`;

export const DefaultG = tw.g``;

export const MapWhiteTG = tw(DefaultG)`
  fill-[#fff]
`;
